window.Shopify.formatMoney = function (t, r) {
  function e(t, r) {
    return void 0 === t ? r : t;
  }
  function a(t, r, a, o) {
    if (((r = e(r, 2)), (a = e(a, ',')), (o = e(o, '.')), isNaN(t) || null == t)) return 0;
    t = (t / 100).toFixed(r);
    var n = t.split('.');
    return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + a) + (n[1] ? o + n[1] : '');
  }
  'string' == typeof t && (t = t.replace('.', ''));
  var o = '',
    n = /\{\{\s*(\w+)\s*\}\}/,
    i = r || this.money_format;
  switch (i.match(n)[1]) {
    case 'amount':
      o = a(t, 2);
      break;
    case 'amount_no_decimals':
      o = a(t, 0);
      break;
    case 'amount_with_comma_separator':
      o = a(t, 2, '.', ',');
      break;
    case 'amount_with_space_separator':
      o = a(t, 2, ' ', ',');
      break;
    case 'amount_with_period_and_space_separator':
      o = a(t, 2, ' ', '.');
      break;
    case 'amount_no_decimals_with_comma_separator':
      o = a(t, 0, '.', ',');
      break;
    case 'amount_no_decimals_with_space_separator':
      o = a(t, 0, ' ', '');
      break;
    case 'amount_with_apostrophe_separator':
      o = a(t, 2, "'", '.');
      break;
    case 'amount_with_decimal_separator':
      o = a(t, 2, '.', '.');
  }
  return i.replace(n, o);
};

const customFunctions = (() => {
  // Function to find option position dynamically
  const findOptionPosition = (product, optionName) => {
    for (let i = 0; i < product.options.length; i++) {
      const currentOptionName = product.options[i].name.toLowerCase().trim();
      if (currentOptionName === optionName.toLowerCase().trim()) {
        return i + 1; // Return 1-based position for option1, option2, option3
      }
    }
    return -1; // Return -1 if option not found
  };

  // Function to get variant option value by position
  const getVariantOptionValue = (variant, position) => {
    switch (position) {
      case 1:
        return variant.option1;
      case 2:
        return variant.option2;
      case 3:
        return variant.option3;
      default:
        return null;
    }
  };

  const wrapElements = (parentEl, wrapperEl) => {
    /*
        Basically this functions is used to add wrapping element between the parent element
        and its content.
    */
    const parentInnerHTML = parentEl.innerHTML;
    wrapperEl.innerHTML = parentInnerHTML;
    parentEl.innerHTML = '';
    parentEl.appendChild(wrapperEl);
  };

  const checkTemplate = () => {
    /*
        How does this work?
        - The ide is that body will have a certain classname that will give the informations about what template are we currently in
        so for example if the body has class "template--collection", we are in collection template, and may run the code that is reserved
        for that collection
    */
    const templateClasses = {
      collectionClass: 'template--collection',
      productClass: 'template--product',
      indexClass: 'template--index',
      pageClass: 'template--page',
      searchClass: 'template--search',
    };

    const body = document.querySelector('body');
    const bodyClasses = body.classList.value;

    for (const className of Object.values(templateClasses)) {
      if (bodyClasses.includes(className)) {
        return className.replace('template--', '');
      }
    }
    return '';
  };
  const SwiperIniter = (isAjax = false) => {
    const customSwiperInitEvent = 'swiperElementLoaded';

    const swiperDatasets = {
      collection: {
        loop: false,
        slidesPerView: 2,
        spaceBetween: 12,
        // If we need pagination
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          800: {
            slidesPerView: 3,
            spaceBetween: 32,
          },
          1024: {
            slidesPerView: 6,
          },
        },
      },
      featured_collection: {
        loop: false,
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 12,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          800: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 32,
          },
          1024: {
            slidesPerView: 6,
            slidesPerGroup: 6,
          },
        },
      },
      banner_with_carousel: {
        loop: false,
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 12,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          800: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 32,
          },
          1024: {
            slidesPerView: 4,
            slidesPerGroup: 6,
          },
        },
      },
      tile_size: {
        loop: false,
        slidesPerView: 4,
        // If we need pagination
        navigation: {
          nextEl: '.swiper-button--size-nav-next',
          prevEl: '.swiper-button--size-nav-prev',
        },
      },
      image_with_content: {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    };

    const initiliazeSwiper = (element, config) => {
      const rand = element.dataset.randNum;
      const elConfig = JSON.parse(JSON.stringify(config)); // Deep clone to avoid modifying original
      if (rand) {
        elConfig.navigation.nextEl = '.swiper-button-next-' + rand;
        elConfig.navigation.prevEl = '.swiper-button-prev-' + rand;
      }
      // Read custom slides per view from data attributes
      const desktopSlides = element.dataset.slidesPerViewDesktop;
      const mobileSlides = element.dataset.slidesPerViewMobile;
      if (desktopSlides && elConfig.breakpoints) {
        // Update 1024px breakpoint if it exists
        if (elConfig.breakpoints[1024]) {
          elConfig.breakpoints[1024].slidesPerView = parseInt(desktopSlides, 10);
          elConfig.breakpoints[1024].slidesPerGroup = parseInt(desktopSlides, 10);
        }
        // Also update 800px breakpoint if it exists (for banner_with_carousel)
        if (elConfig.breakpoints[800]) {
          const desktopValue = parseInt(desktopSlides, 10);
          // Set 800px to be between mobile and desktop (or same as desktop if mobile is close)
          elConfig.breakpoints[800].slidesPerView = Math.min(
            desktopValue,
            Math.max(parseInt(mobileSlides || 2, 10) + 1, 3)
          );
          elConfig.breakpoints[800].slidesPerGroup = elConfig.breakpoints[800].slidesPerView;
        }
      }
      if (mobileSlides) {
        elConfig.slidesPerView = parseInt(mobileSlides, 10);
        elConfig.slidesPerGroup = parseInt(mobileSlides, 10);
      }
      const swiper = new Swiper(element, elConfig);
    };

    const swiperSelect = (swiperElements) => {
      swiperElements.forEach((swiperEl) => {
        const dataConfig = swiperEl.dataset.swiperConfig;
        const swiperConfig = swiperDatasets[dataConfig];
        initiliazeSwiper(swiperEl, swiperConfig);
      });
    };
    const annoucementBarSlider = () => {
      var mySwiper = new Swiper('.announcement-bar-carousel ', {
        effect: 'slide',
        loop: true,
        autoplay: {
          delay: 3000,
        },
      });
    };
    const productCardOptionsCardSlider = () => {
      setInterval(() => {
        const swiperElements = document.querySelectorAll(
          '.swiper-main-el-card:not(.swiper-initialized)'
        );
        if (swiperElements.length > 0) {
          swiperSelect(swiperElements);
        }
      }, 1);
    };

    const textWithCollection = () => {
      const swiper = new Swiper('.twc-swiper-slider', {
        spaceBetween: 10,
        slidesPerView: 2.5, // 4 products on desktop
        slidesPerGroup: 2,
        navigation: {
          nextEl: '.twc-swiper-button-next',
          prevEl: '.twc-swiper-button-prev',
        },
        breakpoints: {
          768: {
            slidesPerView: 4, // 4 products on
            slidesPerGroup: 4,
          },
        },
        on: {
          slideChange: function () {
            const progressBar = document.querySelector('.twc-swiper-progress-bar');
            const progress =
              (this.activeIndex / (this.slides.length - this.params.slidesPerView)) * 100;
            if (progressBar) progressBar.style.width = `${progress}%`;
          },
        },
      });
      // Hide navigation buttons if there are not enough slides
      if (swiper.slides.length <= 1) {
        if (swiper.navigation.nextEl && swiper.navigation.prevEl) {
          swiper.navigation.nextEl.style.display = 'none';
          swiper.navigation.prevEl.style.display = 'none';
        }
      }
    };
    const minicartUpselSlider = () => {
      var miniCartUpsellSlider = new Swiper('.mini-cart_upsell-products ', {
        effect: 'slide',
        slidesPerView: 1.3,
      });
    };
    document.addEventListener(customSwiperInitEvent, () => {
      const swiperElements = document.querySelectorAll('.swiper-main-el');
      swiperSelect(swiperElements);
      productCardOptionsCardSlider();
      annoucementBarSlider();
      // minicartUpselSlider();
      textWithCollection();
    });

    document.addEventListener('productRecommendationsReloaded', () => {
      const productRecomms = document.querySelectorAll(
        'product-recommendations-root[data-is-swiper="true"] .related-products--grid'
      );
      productRecomms.forEach((productRecomm) => {
        const swiperEl = document.createElement('div');
        //creating swiper elemenet and swiper-wrapper
        swiperEl.classList.add('swiper-main-el-ajax');
        swiperEl.setAttribute('data-swiper-config', 'collection');
        const swiperWrapper = document.createElement('div');
        swiperWrapper.classList.add('swiper-wrapper');
        const randomNum = Math.floor(Math.random() * 90000) + 10000;

        swiperEl.setAttribute('data-rand-num', randomNum);
        //adding swiper-slide class to all product grid item
        productRecomm.querySelectorAll('.product--root').forEach((item) => {
          item.classList.add('swiper-slide');
        });

        //wrapping the conent of product-recommendations
        wrapElements(productRecomm, swiperWrapper);
        wrapElements(productRecomm, swiperEl);

        const navigation = document.createElement('div');
        navigation.classList.add('swiper-navigation');
        navigation.innerHTML = `
            <div class="swiper-button-prev swiper-button-prev-${randomNum} swiper-btn-prev">
                <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle opacity="0.8" cx="22.5" cy="22.5" r="22" transform="matrix(-1 0 0 1 45 0)" stroke="black"/>
                <path d="M18.2929 22.7071C17.9024 22.3166 17.9024 21.6834 18.2929 21.2929L24.6569 14.9289C25.0474 14.5384 25.6805 14.5384 26.0711 14.9289C26.4616 15.3195 26.4616 15.9526 26.0711 16.3431L20.4142 22L26.0711 27.6569C26.4616 28.0474 26.4616 28.6805 26.0711 29.0711C25.6805 29.4616 25.0474 29.4616 24.6569 29.0711L18.2929 22.7071ZM21 23H19V21H21V23Z" fill="black"/>
                </svg>
            </div>
            <div class="swiper-button-next swiper-button-next-${randomNum} swiper-btn-next">
                <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle opacity="0.8" cx="22.5" cy="22.5" r="22" stroke="black"/>
                <path d="M26.7071 22.7071C27.0976 22.3166 27.0976 21.6834 26.7071 21.2929L20.3431 14.9289C19.9526 14.5384 19.3195 14.5384 18.9289 14.9289C18.5384 15.3195 18.5384 15.9526 18.9289 16.3431L24.5858 22L18.9289 27.6569C18.5384 28.0474 18.5384 28.6805 18.9289 29.0711C19.3195 29.4616 19.9526 29.4616 20.3431 29.0711L26.7071 22.7071ZM24 23H26V21H24V23Z" fill="black"/>
                </svg>
            </div>
        `;
        swiperEl.appendChild(navigation);
      });

      const swiperElements = document.querySelectorAll('.swiper-main-el-ajax');
      swiperSelect(swiperElements);
    });

    if (isAjax) {
      const swiperElements = document.querySelectorAll('.swiper-main-el');
      swiperSelect(swiperElements);
    }
  };

  const CollectionTiles = () => {
    //product-root__link
    const form = document.querySelector('.product-buy-buttons--form-quick-add');
    // if (checkTemplate() !== "collection") return;
    const getProductHrefLink = (link) => {
      if (!link.includes('?')) {
        return link;
      } else {
        return link.split('?')[0];
      }
    };
    const setNewSizes = (anchorTag, swatch) => {
      //swap size product tiles
      const sizes = anchorTag.querySelector('.product-tile__size-box');
      if (!sizes) return;
      const avaibleSizes = swatch.dataset.avaibleSizes;

      if (!avaibleSizes) return;
      const avaibleSizesArr = avaibleSizes.split(',');
      const currentAvaibleSizes = sizes.querySelectorAll('.product-tile__size-selector');
      currentAvaibleSizes.forEach((currentAvaibleSize) => {
        const size = currentAvaibleSize.dataset.value;
        if (avaibleSizesArr.includes(size)) {
          currentAvaibleSize.classList.remove('product-tile__size-selector--unavaible');
        } else {
          currentAvaibleSize.classList.add('product-tile__size-selector--unavaible');
        }
      });
    };
    const swapInImages = (r, t) => {
      var e = t.querySelectorAll('.cart--item');

      return (
        0 !== e.length &&
        (e.forEach((t) => {
          var e = t.querySelector('.cart--item--image'),
            a = r.querySelector(
              `[data-variant-id='${t.getAttribute('data-variant-id')}'] .cart--item--image`
            );
          a && e && e.replaceWith(a);
        }),
        t)
      );
    };
    const swapInNewContent = (t) => {
      var e = document.querySelector('.cart-popup .class-items'),
        a = t.querySelector('.class-items'),
        a = swapInImages(e, a),
        r = (e && a && e.replaceWith(a), document.querySelector('.cart--total--price')),
        o = t.querySelector('.cart--total--price');
      r && o && r.replaceWith(o);
    };
    const cartNotifPopup = document.querySelector('cart-notification');
    let responseCount = 0;
    setInterval(() => {
      const productTiles = document.querySelectorAll('.product--root:not(.added-event)');

      if (productTiles.length > 0) {
        productTiles.forEach((productTile) => {
          productTile.classList.add('added-event');
          const anchor = productTile.querySelector('.product-root__link');
          anchor.addEventListener('click', (event) => {
            const target = event.target;

            // Check if the target is div.box or one of its children
            if (
              target.classList.contains('product-tile__size-main') ||
              target.closest('.product-tile__size-main') ||
              target.classList.contains('product--swatches--column-view') ||
              target.closest('.product--swatches--column-view') ||
              target.classList.contains('product--swatches--column-view-swatches-hidden')
            ) {
              event.preventDefault(); // Prevent the default link behavior
              // Add any custom code you want to run when div.box or its children are clicked here
            }
          });
          const sizeSelectors = productTile.querySelectorAll('.product-tile__size-selector');
          sizeSelectors.forEach((sizeSelector) => {
            sizeSelector.addEventListener('click', () => {
              if (sizeSelector.classList.contains('product-tile__size-selector--unavaible')) return;
              const sizeValue = sizeSelector.dataset.value;
              const anchorTag = sizeSelector.closest('.product-root__link');
              const sizeTtitle = anchorTag.querySelector('.product-tile__size-title');
              const singleSize = anchorTag.querySelector('.single-size');
              if (singleSize) {
                singleSize.textContent = 'Adding To Bag';
              } else if (sizeTtitle) {
                sizeTtitle.textContent = 'Adding To Bag';
              }

              const productLink = getProductHrefLink(anchorTag.getAttribute('href')) + '.json';
              fetch(productLink)
                .then((response) => response.json())
                .then(async (data) => {
                  let variantId = data.product.variants[0].id;

                  if (data.product.options.length === 1) {
                    const sizeOptionPosition = findOptionPosition(data.product, 'size');
                    if (sizeOptionPosition !== -1) {
                      const variant = data.product.variants.find((variant) => {
                        const variantSize = getVariantOptionValue(variant, sizeOptionPosition);
                        return variantSize && variantSize.toLowerCase() === sizeValue.toLowerCase();
                      });
                      if (variant) variantId = variant.id;
                    }
                  } else {
                    const selectedColor = anchorTag.dataset.varColor;
                    const colorOptionPosition = findOptionPosition(data.product, 'color');
                    const sizeOptionPosition = findOptionPosition(data.product, 'size');

                    console.log(selectedColor);
                    console.log(sizeValue);

                    if (colorOptionPosition !== -1 && sizeOptionPosition !== -1) {
                      const filteredVars = data.product.variants.filter((variant) => {
                        const variantColor = getVariantOptionValue(variant, colorOptionPosition);
                        return (
                          variantColor && variantColor.toLowerCase() === selectedColor.toLowerCase()
                        );
                      });

                      let variant = filteredVars.find((variant) => {
                        const variantSize = getVariantOptionValue(variant, sizeOptionPosition);
                        return variantSize && variantSize.toLowerCase() === sizeValue.toLowerCase();
                      });

                      if (!variant) {
                        // Fallback: try to find variant by size only
                        variant = data.product.variants.find((variant) => {
                          const variantSize = getVariantOptionValue(variant, sizeOptionPosition);
                          return (
                            variantSize && variantSize.toLowerCase() === sizeValue.toLowerCase()
                          );
                        });
                      }

                      if (variant) variantId = variant.id;
                    }
                  }
                  const config = fetchConfig('javascript');
                  config.headers['X-Requested-With'] = 'XMLHttpRequest';
                  delete config.headers['Content-Type'];
                  const form = document.querySelector('.product-buy-buttons--form-quick-add');
                  const formData = new FormData(form);

                  if (cartNotifPopup) {
                    formData.append(
                      'sections',
                      cartNotifPopup.getSectionsToRender().map((section) => section.id)
                    );
                    formData.append('sections_url', window.location.pathname);
                    formData.append('id', variantId);
                    formData.append('product-id', data.product.id);
                    cartNotifPopup.setActiveElement(document.activeElement);
                  }

                  //formData.append("items", [{ id: variantId, quantity: 1, selling_plan: null }])
                  config.body = formData;

                  fetch(`${theme.urls.cart_add}`, config)
                    .then((response) => response.json())
                    .then(async (response) => {
                      if (response.status) {
                        if (typeof maxItemsError) maxItemsError();
                      } else {
                        if (singleSize) {
                          singleSize.textContent = 'Item Added To Bag';
                        } else if (sizeTtitle) {
                          sizeTtitle.textContent = 'Item Added To Bag';
                        }
                        cartNotifPopup.renderContents(response);
                        cartNotifPopup.setActiveElement(document.activeElement);
                        (await theme.cart.fetchTotals(),
                          theme.cart.updateAllHtml(!0),
                          window.trigger('theme:cart:productAdded', variantId));
                      }
                      setTimeout(() => {
                        if (singleSize) {
                          singleSize.textContent = 'Add To Bag';
                        } else if (sizeTtitle) {
                          sizeTtitle.textContent = 'Add To Bag';
                        }
                      }, 700);
                    });
                });

              const colorSwatchesContainers = productTile.querySelectorAll('.radios--main');
              colorSwatchesContainers.forEach((swatchContainer, indexSwatch) => {
                swatchContainer.addEventListener('click', () => {
                  const swatch = swatchContainer.querySelector('input');
                  const swatchColor = swatch.value;
                  const anchorTag = swatch.closest('.product-root__link');
                  anchorTag.setAttribute('data-var-color', swatchColor);
                  const productLink = anchorTag.getAttribute('href') + '.json';

                  swatch.checked = true;
                  fetch(productLink)
                    .then((response) => response.json())
                    .then((data) => {
                      const variant = data.product.variants.find(
                        (variant) => variant.option1.toLowerCase() === swatchColor.toLowerCase()
                      );

                      const productImages = data.product.images;
                      let targetImg = productImages.find(
                        (productImg) => productImg.id == variant.image_id
                      );
                      if (!targetImg) targetImg = data.product.image;

                      const imgs = anchorTag.querySelectorAll('.product--image-wrapper img');

                      imgs.forEach((img) => {
                        img.src = targetImg.src;
                        img.dataset.src = targetImg.src;
                        img.removeAttribute('srcset');
                      });

                      setNewSizes(anchorTag, swatch);
                    });
                });
              });
            });
          });
        });
      }
    }, 1);

    document.addEventListener('DOMContentLoaded', () => {
      const plusColors = document.querySelectorAll(
        '.product--swatches--column-view-swatches-hidden'
      );
      plusColors.forEach((plusColorEl) => {
        plusColorEl.addEventListener('click', () => {
          const anchorTag = plusColorEl.closest('.product-root__link');

          const colorsSwatches = anchorTag.querySelector('.product--swatches--column-view');
          if (plusColorEl.innerText != '' && plusColorEl.innerText != ' ') {
            colorsSwatches.style.display = 'block';
            plusColorEl.style.display = 'none';
          }
        });
      });
    });
  };
  const sortByFilterLogic = () => {
    const template = checkTemplate();
    if (template != 'collection' && template != 'search') return;
    const navigationFilter = document.querySelector('navigation-filter');
    if (!navigationFilter) return;
    const sortToggle = navigationFilter.querySelector('.filter--toggle');
    const filterInputs = navigationFilter.querySelectorAll('.filter--input');
    filterInputs.forEach((filterInput) => {
      filterInput.addEventListener('change', () => {
        // The main filter form sits beside the grid from 768px up and in the drawer below it
        const mainSortInput = [
          ...document.querySelectorAll('.filter--root [data-type="sort"] .filter--input'),
        ].find((input) => input.value == filterInput.value);
        mainSortInput && mainSortInput.nextElementSibling.click();
      });
    });
    document.addEventListener('click', (event) => {
      if (!sortToggle || sortToggle.getAttribute('aria-expanded') !== 'true') return;
      if (event.target.closest('navigation-filter .filter--category')) return;
      sortToggle.click();
    });
  };
  const showFiltersBtnMobile = () => {
    const template = checkTemplate();
    if (template != 'collection' && template != 'search') return;
    const showFiltersMobile = document.querySelector('.product--filter--toggle--mobile');
    if (!showFiltersMobile) return;
    showFiltersMobile.addEventListener('click', () => {
      const browseBtn = document.querySelector(
        `.navigation--mobile-button[data-toggle-menu="browse-filter"]`
      );
      browseBtn && browseBtn.click();
    });
  };
  const faqsSliderLinks = () => {
    let layoutMainContent = document.querySelector('.faqs-link-section');
    let options = {
        childList: true,
      },
      observer = new MutationObserver(mCallback);
    if (layoutMainContent) observer.observe(layoutMainContent, options);
    function mCallback(mutations) {
      for (let mutation of mutations) {
        if (mutation.type === 'childList') {
          let faqsItems = document.querySelectorAll('.faqs-link-section a');
          if (faqsItems) {
            faqsItems.forEach((element, index) => {
              element.addEventListener('click', function (e) {
                e.preventDefault();
                let headerHight =
                  document.querySelector('.layout--header-group')?.getBoundingClientRect().height +
                  20;
                window.scrollTo(
                  0,
                  document.querySelector(`${element.getAttribute('href')}`)?.offsetTop - headerHight
                );
              });
            });
          }
        }
      }
    }
  };

  return {
    SwiperIniter,
    CollectionTiles,
    sortByFilterLogic,
    showFiltersBtnMobile,
    faqsSliderLinks,
  };
})();

customFunctions.SwiperIniter();

customFunctions.CollectionTiles();

customFunctions.sortByFilterLogic();

customFunctions.showFiltersBtnMobile();
customFunctions.faqsSliderLinks();

document.addEventListener('productRecommendationsReloaded', () => {
  setTimeout(() => {
    customFunctions.SwiperIniter(true);
    customFunctions.CollectionTiles();
  }, 300);
});

// toggling the product filter
const filterToggle = document.querySelector('.product--filter--toggle');
const filterContainer =
  document.querySelector('.filter--root') || document.querySelector('.filter--root--new');

const collectionBody =
  document.querySelector('.collection--body--container') ||
  document.querySelector('.search-results--body--container');
const collectionGrid =
  document.querySelector('.collection--body--grid') ||
  document.querySelector('.search-results--products');
if (filterToggle && filterContainer && collectionBody && collectionGrid) {
  filterToggle.addEventListener('click', () => {
    const collectionProduct = collectionGrid.querySelectorAll('.product--root');
    filterContainer.classList.toggle('closed');
    collectionBody.classList.toggle('full');
    if (filterContainer.classList.contains('closed')) {
      filterToggle.textContent = 'Show Filters';
      filterContainer.style.maxWidth = 0;
      if (window.screen.width > 767) {
        /*setTimeout(() => {
          filterContainer.style.position = "absolute";
        }, 700);*/
      }
    } else {
      filterToggle.textContent = 'hide filters';
      // Use a fixed max width so the grid always keeps space (never use product width which can squeeze the grid)
      const filterMaxWidth = window.screen.width > 767 ? '280px' : '100%';
      filterContainer.style.maxWidth = filterMaxWidth;
      setTimeout(() => {
        filterContainer.style.position = 'sticky';
      }, 100);
    }
    window.addEventListener('resize', () => {
      if (window.screen.width < 768) {
        filterContainer.style.position = 'static';
      } else {
        filterContainer.style.position = 'sticky';
      }
    });
  });
}

const maxItemsError = () => {
  const error = document.createElement('div');
  error.classList.add('error--message');
  error.textContent = 'You have all available inventory of this product in the cart';
  document.querySelector('body').appendChild(error);
  setTimeout(() => {
    error.remove();
  }, 3000);
};

setInterval(() => {
  const ctaElements = document.querySelectorAll('.product-buy-buttons--cta-text');

  ctaElements.forEach((element) => {
    if (
      element.classList.contains('changed-text') != -1 &&
      element.closest('.gPreorderBtn') == null
    ) {
      element.textContent = 'ADD TO BAG';
      element.classList.add('changed-text');
    }
  });
}, 500);

class CustomVariantPicker extends HTMLElement {
  constructor() {
    super();
    this.bindEvents = this.bindEvents.bind(this);
    this.onVariantChange = this.onVariantChange.bind(this);
  }

  connectedCallback() {
    this.productId = this.dataset.productId;
    this.product = JSON.parse(this.dataset.product);
    this.variants = this.product.variants;
    this.options = Array.from(this.querySelectorAll('input[type="radio"]'));
    this.onVariantChange();
    this.bindEvents();
  }

  bindEvents() {
    this.options.forEach((input) => {
      input.addEventListener('change', this.onVariantChange);
    });
  }
  formatMoney(cents) {
    // Use Shopify's formatter if available, otherwise use a basic formatter
    if (window.Shopify?.formatMoney) {
      return window.Shopify.formatMoney(cents, window.theme.moneyFormat || '${{amount}}');
    }

    // Basic fallback formatter
    const amount = (cents / 100).toFixed(2);
    return `$${amount}`;
  }
  async onVariantChange() {
    const selectedOptions = this.getSelectedOptions();
    const selectedVariant = this.findVariant(selectedOptions);

    if (selectedVariant && selectedVariant.id) {
      if (this.closest('.mini-cart-upsell-item ')) {
        this.closest('.mini-cart-upsell-item ')
          .querySelector('[data-variant-id]')
          .setAttribute('data-variant-id', selectedVariant.id);
        if (selectedVariant.available) {
          this.closest('.mini-cart-upsell-item ')
            .querySelector('[data-variant-id]')
            .removeAttribute('disabled');
          this.closest('.mini-cart-upsell-item ').querySelector('[data-variant-id]').textContent =
            'ADD';
          document.querySelectorAll('cart-root .cart--item').forEach((item) => {
            if (parseInt(item.dataset.variantId) == selectedVariant.id) {
              this.closest('.mini-cart-upsell-item ').querySelector(
                '[data-variant-id]'
              ).textContent = 'ADDED TO BAG';
              this.closest('.mini-cart-upsell-item ')
                .querySelector('[data-variant-id]')
                .setAttribute('disabled', true);
            }
          });
        } else {
          this.closest('.mini-cart-upsell-item ')
            .querySelector('[data-variant-id]')
            .setAttribute('disabled', true);
          this.closest('.mini-cart-upsell-item ').querySelector('[data-variant-id]').textContent =
            'Sold out';
        }
      }
      console.log(selectedVariant);

      if (this.closest('.mini-cart_gift-wrap-item')) {
        this.closest('.mini-cart_gift-wrap-item')
          .querySelector('[data-variant-id]')
          .setAttribute('data-variant-id', selectedVariant.id);
        if (selectedVariant.available) {
          this.closest('.mini-cart_gift-wrap-item')
            .querySelector('[data-variant-id]')
            .removeAttribute('disabled');
          this.closest('.mini-cart_gift-wrap-item').querySelector('[data-variant-id]').textContent =
            'ADD';
          document.querySelectorAll('cart-root .cart--item').forEach((item) => {
            if (parseInt(item.dataset.variantId) == selectedVariant.id) {
              this.closest('.mini-cart_gift-wrap-item').querySelector(
                '[data-variant-id]'
              ).textContent = 'ADDED TO BAG';
              this.closest('.mini-cart_gift-wrap-item')
                .querySelector('[data-variant-id]')
                .setAttribute('disabled', true);
            }
          });
        } else {
          this.closest('.mini-cart_gift-wrap-item')
            .querySelector('[data-variant-id]')
            .setAttribute('disabled', true);
          this.closest('.mini-cart_gift-wrap-item').querySelector('[data-variant-id]').textContent =
            'Sold out';
        }
      }

      if (this.closest('.pup-upsell-item')) {
        this.closest('.pup-upsell-item')
          .querySelector('[data-variant-id]')
          .setAttribute('data-variant-id', selectedVariant.id);
        if (selectedVariant.available) {
          this.closest('.pup-upsell-item')
            .querySelector('[data-variant-id]')
            .removeAttribute('disabled');
          this.closest('.pup-upsell-item').querySelector('[data-variant-id]').innerHTML =
            `<span>ADD TO BAG - ${this.formatMoney(selectedVariant.price)}</span>`;
          document.querySelectorAll('cart-root .cart--item').forEach((item) => {
            if (parseInt(item.dataset.variantId) == selectedVariant.id) {
              this.closest('.pup-upsell-item').querySelector('[data-variant-id]').innerHTML =
                '<span>ADDED TO BAG</span>';
              this.closest('.pup-upsell-item')
                .querySelector('[data-variant-id]')
                .setAttribute('disabled', true);
            }
          });
        } else {
          this.closest('.pup-upsell-item')
            .querySelector('[data-variant-id]')
            .setAttribute('disabled', true);
          this.closest('.pup-upsell-item').querySelector('[data-variant-id]').innerHTML =
            '<span>Sold out</span>';
        }
      }
      // hadlebutton text

      // variant option status change
      this.options.forEach((option) => {
        let sOptions = this.getSelectedOptions();
        const optionOffset = parseInt(option.getAttribute('data-option-offset'));
        sOptions[optionOffset] = option.value;
        const sVariant = this.findVariant(sOptions);
        if (sVariant && sVariant.available) {
          option.closest('.variant-option').classList.remove('disabled');
        } else {
          option.closest('.variant-option').classList.add('disabled');
        }
      });
    }
  }

  getSelectedOptions() {
    const selectedOptions = [];
    const uniqueId = `custom-variant-picker-${this.productId}`;

    // Get all option names from product.options_with_values
    if (this.product.options && Array.isArray(this.product.options)) {
      this.product.options.forEach((option, index) => {
        const selected = this.querySelector(`input[name="${uniqueId}-${option}"]:checked`);
        selectedOptions[index] = selected ? selected.value : null;
      });
    }

    return selectedOptions;
  }

  findVariant(selectedOptions) {
    if (!this.variants || !Array.isArray(this.variants)) {
      return null;
    }

    return this.variants.find((variant) => {
      return variant.options.every((option, index) => option === selectedOptions[index]);
    });
  }

  disconnectedCallback() {
    this.options.forEach((input) => {
      input.removeEventListener('change', this.onVariantChange);
    });
  }
}

if (!customElements.get('custom-variant-picker')) {
  customElements.define('custom-variant-picker', CustomVariantPicker);
}

document.querySelectorAll('custom-variant-picker').forEach((picker) => {
  picker.addEventListener('variant:changed', (event) => {
    const { productId, variant } = event.detail;
  });
});
